import { render } from "./HeaderNotification.vue?vue&type=template&id=a702448e&scoped=true"
import script from "./HeaderNotification.vue?vue&type=script&lang=js"
export * from "./HeaderNotification.vue?vue&type=script&lang=js"

import "./HeaderNotification.vue?vue&type=style&index=0&id=a702448e&scoped=true&lang=css"
import "./HeaderNotification.vue?vue&type=style&index=1&id=a702448e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a702448e"]])

export default __exports__